// extracted by mini-css-extract-plugin
export default {"utopiaPage":"UtopiaPage_utopiaPage__URAe6"};